import { MdCode } from 'react-icons/md'
import logoBox from '../Asset/img/mim.jpg'
export const servicesData = [
    {
        id: 1,
        imgSrc: logoBox,
        service: 'Website Developing',
        caption: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        btnText: 'Read More',
        icoBox: <MdCode className='s-ico'/>
    },
    {
        id: 2,
        imgSrc: logoBox,
        service: 'Website Developing',
        caption: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        btnText: 'Read More',
        icoBox: <MdCode className='s-ico'/>
    },
    {
        id: 3,
        imgSrc: logoBox,
        service: 'Website Developing',
        caption: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        btnText: 'Read More',
        icoBox: <MdCode className='s-ico'/>
    },
    {
        id: 4,
        imgSrc: logoBox,
        service: 'Website Developing',
        caption: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi obcaecati numquam, quo nobis corporis aliquid illo magni veritatis consequuntur libero incidunt dolor, placeat velit dolore reiciendis, ab eum alias est.',
        btnText: 'Read More',
        icoBox: <MdCode className='s-ico'/>
    },
    
]